import { fetch } from "../network";
import { opportunityConfigs } from "./constants";
import { OpportunitySerializer } from "./serializer";

const serializer = OpportunitySerializer();

export function OpportunityController() {
	const create = async (body) => {
		const config = opportunityConfigs.create;
		return new Promise((resolve, reject) => {
			serializer
				.create(body)
				.then((serializedBody) => {
					fetch(config.method, config.endpoint, serializedBody)
						.then((response) => resolve(response.data))
						.catch((error) => reject(error.response));
				})
				.catch((error) => reject(error));
		});
	};

	const read = async (body) => {
		if (!body)
			body = {
				offset: 0,
				limit: 10,
			};
		const config = opportunityConfigs.read;
		const query = [`offset=${body.offset}`, `limit=${body.limit}`, `order=${body.order}`, `desc=${body.desc}`, `project_name=${body.search}`];
		return new Promise((resolve, reject) => {
			fetch(config.method, `${config.endpoint}?${query.join("&")}`)
				.then((response) => resolve(response.data))
				.catch((error) => reject(error.response));
		});
	};

	const getById = async (id) => {
		const config = opportunityConfigs.get_by_id;
		return new Promise((resolve, reject) => {
			fetch(config.method, `${config.endpoint}/${id}`)
				.then((response) => resolve(response.data))
				.catch((error) => reject(error.response));
		});
	};

	const updateVisibility = async (id, body) => {
		const config = opportunityConfigs.updateVisibility;
		const endpoint = config.endpoint.replace("$id", id);
		return new Promise((resolve, reject) => {
			fetch(config.method, `${endpoint}`, body)
				.then((response) => resolve(response.data))
				.catch((error) => reject(error.response));
		});
	};

	const deleteOpportunity = async (id) => {
		const config = opportunityConfigs.delete;
		const endpoint = config.endpoint.replace("$id", id);
		return new Promise((resolve, reject) => {
			fetch(config.method, `${endpoint}`)
				.then((response) => resolve(response.data))
				.catch((error) => reject(error.response));
		});
	};

	return Object.freeze({
		create,
		read,
		getById,
		updateVisibility,
		deleteOpportunity,
	});
}
